import { VueRenderer } from '@tiptap/vue-3';
import tippy from 'tippy.js';
import MentionList from './MentionList.vue';

const filterItems = (items, query) => {
  if (!query) {
    return items;
  }

  const keyword = String(query).toLowerCase();
  return items.filter(item => {
    return (
      String(item.value || '')
        .toLowerCase()
        .includes(keyword) ||
      String(item.label || '')
        .toLowerCase()
        .includes(keyword)
    );
  });
};

const createSuggestionRenderer = () => {
  let component;
  let popup;
  let resizeObserver;

  return {
    onStart: props => {
      component = new VueRenderer(MentionList, {
        props,
        editor: props.editor
      });

      if (!props.clientRect) {
        return;
      }

      popup = tippy('body', {
        getReferenceClientRect: props.clientRect,
        appendTo: () => document.body,
        content: component.element,
        showOnCreate: true,
        interactive: true,
        trigger: 'manual',
        placement: 'bottom-start',
        flipOnUpdate: true,
        onShown(instance) {
          if (component.element && !resizeObserver) {
            resizeObserver = new ResizeObserver(() => {
              instance.popperInstance?.update();
            });
            resizeObserver.observe(component.element);
          }
        }
      });
    },

    onUpdate(props) {
      component.updateProps(props);

      if (!props.clientRect || !popup?.[0]) {
        return;
      }

      popup[0].setProps({
        getReferenceClientRect: props.clientRect
      });
    },

    onKeyDown(props) {
      if (props.event.key === 'Escape') {
        popup?.[0]?.hide();
        return true;
      }

      return component.ref?.onKeyDown(props);
    },

    onExit() {
      if (resizeObserver) {
        resizeObserver.disconnect();
        resizeObserver = null;
      }
      popup?.[0]?.destroy();
      component?.destroy();
    }
  };
};

export const createVariableSuggestions = itemsGetter =>
  Object.entries(itemsGetter() || {})
    .filter(([char, items]) => char && Array.isArray(items))
    .map(([char]) => ({
      char,
      allowedPrefixes: null,
      items: ({ query }) => {
        const latestItems = itemsGetter()?.[char] || [];
        return filterItems(latestItems, query);
      },
      render: createSuggestionRenderer
    }));
